
import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '../../lib/models/User'

import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import BacInput from '@/components/BacInput.vue'
import UIkit from 'uikit'

@Component({
  components: {
    BacButton,
    BacModal,
    BacInput
  }
})
export default class ChangeBirthdayModal extends Vue {
  @Prop({ default: () => new User() }) user!: User

  async updateUser () {
    await this.user.update()
    UIkit.notification({
      message: 'Teilnehmer geupdated!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}
